/* bf G3 – Newsletter-Formular (Shopify-Kundenformular, Double Opt-in).
   R64: Das Formular wird normal abgeschickt (kein fetch mehr). Grund: Shopifys Spam-Schutz faengt das Absenden ab,
   holt sich ein Pruef-Token und schickt das Formular danach selbst noch einmal ab. Mit fetch zeigte die Seite erst
   "Fast geschafft" und lud dann trotzdem neu – oben auf der Seite, ohne Hinweis.
   Jetzt: Pruefung der E-Mail im Browser, dann Absenden. Nach dem Neuladen (Shopify: ?customer_posted=true bzw.
   Formular mit Fehler) springt die Seite zum Formular und zeigt die Erfolgs- bzw. Fehlermeldung; wurde im Exit-Layer
   angemeldet, oeffnet sich der Layer mit der Erfolgsmeldung. Loest "bf:newsletter:success" aus. */
(function () {
  if (window.bfNewsletterReady) return
  window.bfNewsletterReady = true

  const SENT = 'bf-nl-sent'
  const posted = /[?&]customer_posted=true(&|$)/.test(window.location.search)
  if (posted) window.bfNewsletterPosted = true // fuer den Exit-Layer (nicht mehr automatisch oeffnen)

  function showError (form, text) {
    const box = form.querySelector('[data-bf-nl-error]')
    const input = form.querySelector('input[type="email"]')
    if (box) { box.textContent = text; box.hidden = false }
    if (input) { input.setAttribute('aria-invalid', 'true'); input.focus() }
  }

  function clearError (form) {
    const box = form.querySelector('[data-bf-nl-error]')
    const input = form.querySelector('input[type="email"]')
    if (box) { box.textContent = ''; box.hidden = true }
    if (input) input.removeAttribute('aria-invalid')
  }

  function showSuccess (form) {
    const fields = form.querySelector('.bf-nl-form__fields')
    const ok = form.querySelector('[data-bf-nl-success]')
    if (fields) fields.hidden = true
    if (ok) ok.hidden = false
    const live = form.querySelector('[data-bf-nl-live]')
    const title = ok && ok.querySelector('.bf-nl-form__success-title')
    if (live && title) live.textContent = title.textContent
    return ok
  }

  /** Formular sichtbar machen: im Exit-Layer den Layer oeffnen, sonst hinscrollen */
  function reveal (form, focusEl) {
    const layer = form.closest('bf-exit-intent')
    if (layer && typeof layer.open === 'function') {
      layer.open()
    } else {
      form.scrollIntoView({ block: 'center' })
    }
    if (focusEl && focusEl.focus) focusEl.focus({ preventScroll: true })
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest && e.target.closest('form[data-bf-nl]')
    if (!form) return
    clearError(form)
    const input = form.querySelector('input[type="email"]')
    if (input && !input.checkValidity()) {
      e.preventDefault()
      showError(form, input.value ? 'Bitte gib eine gültige E-Mail-Adresse ein.' : 'Bitte gib deine E-Mail-Adresse ein.')
      return
    }
    // Normal absenden lassen (auch wenn der Spam-Schutz von Shopify dazwischen geht); merken, welches Formular es war
    form.classList.add('is-busy')
    try { window.sessionStorage.setItem(SENT, form.id || '') } catch (err) {}
  })

  function afterReload () {
    let sentId = ''
    try {
      sentId = window.sessionStorage.getItem(SENT) || ''
      window.sessionStorage.removeItem(SENT)
    } catch (err) {}
    const forms = Array.from(document.querySelectorAll('form[data-bf-nl]'))
    if (!forms.length) return
    let hashId = ''
    try { hashId = decodeURIComponent((window.location.hash || '').slice(1)) } catch (err) {}
    const byId = (id) => (id ? forms.find((f) => f.id === id) : null)
    const outside = forms.find((f) => !f.closest('bf-exit-intent'))

    if (posted) {
      const form = byId(sentId) || byId(hashId) || outside || forms[0]
      const ok = showSuccess(form)
      reveal(form, ok)
      document.dispatchEvent(new CustomEvent('bf:newsletter:success', { detail: { form } }))
      // Parameter entfernen, damit ein spaeteres Neuladen nicht erneut "Fast geschafft" zeigt
      window.addEventListener('load', () => {
        try {
          const url = new URL(window.location.href)
          url.searchParams.delete('customer_posted')
          url.hash = ''
          window.history.replaceState(window.history.state, '', url.pathname + url.search)
        } catch (err) {}
      }, { once: true })
      return
    }
    // Fehler von Shopify (z. B. ungueltige Adresse): zum Formular mit der Meldung springen
    if (!sentId && !hashId) return
    const withError = forms.find((f) => {
      const box = f.querySelector('[data-bf-nl-error]')
      return box && !box.hidden && box.textContent.trim()
    })
    if (withError) reveal(withError, withError.querySelector('input[type="email"]'))
  }

  // Nach DOMContentLoaded, damit der Exit-Layer (bf-exit-intent.js, ebenfalls defer) schon definiert ist
  let ran = false
  const run = () => { if (!ran) { ran = true; afterReload() } }
  if (document.readyState === 'complete') run()
  else {
    document.addEventListener('DOMContentLoaded', run, { once: true })
    window.addEventListener('load', run, { once: true })
  }
})()
